import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Clock, MapPin, Users, X, ZoomIn, Camera } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const EvenementsPage = () => {
  const [lightboxData, setLightboxData] = useState(null);

  const openLightbox = (images, currentIndex) => {
    setLightboxData({ images, currentIndex });
  };

  const closeLightbox = () => {
    setLightboxData(null);
  };

  const goToPrevious = () => {
    if (lightboxData) {
      const newIndex = lightboxData.currentIndex === 0 
        ? lightboxData.images.length - 1 
        : lightboxData.currentIndex - 1;
      setLightboxData({ ...lightboxData, currentIndex: newIndex });
    }
  };

  const goToNext = () => {
    if (lightboxData) {
      const newIndex = lightboxData.currentIndex === lightboxData.images.length - 1 
        ? 0 
        : lightboxData.currentIndex + 1;
      setLightboxData({ ...lightboxData, currentIndex: newIndex });
    }
  };

  // Événements passés avec photos du stage de Padel
  const pastEvents = [
    {
      title: "Apéro de soutien - Vamos Melina",
      date: "Vendredi 30 mai 2026",
      description: "Matinée de soutien à Melina : match d'exhibition Melina (R4) - Mireille (R3), 1-Point Challenge juniors, bricolage & concours, café-croissant et apéro avec l'AVB.",
      images: [
        { src: '/events/apero-melina.jpeg', alt: 'Flyer Apéro Vamos Melina' }
      ]
    },
    {
      title: "Assemblée Générale",
      date: "Jeudi 26 mars 2026",
      description: "Assemblée générale du TC Cheyres-Châbles. Bilan de la saison et discussion des projets à venir.",
      images: []
    },
    {
      title: "Stage/Initiation de Padel",
      date: "Samedi matin 31 mai 2025",
      description: "Une matinée d'initiation au padel pour découvrir ce sport passionnant et accessible à tous.",
      images: [
        { 
          src: 'https://customer-assets.emergentagent.com/job_clubtennis-update/artifacts/fdxdzle8_WhatsApp%20Image%202025-10-11%20at%2017.54.32.jpeg', 
          alt: 'Stage Padel - Joueurs sur le terrain' 
        },
        { 
          src: 'https://customer-assets.emergentagent.com/job_clubtennis-update/artifacts/b4jxov5x_WhatsApp%20Image%202025-10-11%20at%2017.54.23.jpeg', 
          alt: 'Stage Padel - Initiation en cours' 
        },
        { 
          src: 'https://customer-assets.emergentagent.com/job_clubtennis-update/artifacts/7l205z1i_WhatsApp%20Image%202025-10-11%20at%2017.54.11.jpeg', 
          alt: 'Stage Padel - Apprentissage des techniques' 
        },
        { 
          src: 'https://customer-assets.emergentagent.com/job_clubtennis-update/artifacts/8kx3b6nt_WhatsApp%20Image%202025-10-11%20at%2017.54.02.jpeg', 
          alt: 'Stage Padel - Participants en action' 
        },
        { 
          src: 'https://customer-assets.emergentagent.com/job_clubtennis-update/artifacts/a84k5l21_WhatsApp%20Image%202025-10-11%20at%2017.53.46.jpeg', 
          alt: 'Stage Padel - Vue du terrain avec participants' 
        },
        { 
          src: 'https://customer-assets.emergentagent.com/job_clubtennis-update/artifacts/9g2v928v_WhatsApp%20Image%202025-10-11%20at%2017.55.03.jpeg', 
          alt: 'Stage Padel - Groupe de participants' 
        },
        { 
          src: 'https://customer-assets.emergentagent.com/job_clubtennis-update/artifacts/m0fg9goi_WhatsApp%20Image%202025-10-11%20at%2017.54.42.jpeg', 
          alt: 'Stage Padel - Session de jeu' 
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />
      
      {/* Lightbox Modal with Navigation */}
      {lightboxData && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          {/* Close button */}
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
          >
            <X className="w-10 h-10" />
          </button>

          {/* Previous button */}
          {lightboxData.images.length > 1 && (
            <button
              onClick={(e) => { e.stopPropagation(); goToPrevious(); }}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors z-10"
            >
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}

          {/* Next button */}
          {lightboxData.images.length > 1 && (
            <button
              onClick={(e) => { e.stopPropagation(); goToNext(); }}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors z-10"
            >
              <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          )}

          {/* Image */}
          <img
            src={lightboxData.images[lightboxData.currentIndex].src}
            alt={lightboxData.images[lightboxData.currentIndex].alt}
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />

          {/* Photo counter */}
          {lightboxData.images.length > 1 && (
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white bg-black/50 px-4 py-2 rounded-full">
              {lightboxData.currentIndex + 1} / {lightboxData.images.length}
            </div>
          )}
        </div>
      )}
      
      <div className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>
          
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Prochains Événements
            </h1>
            <p className="text-xl text-gray-600">
              Découvrez les événements et activités à venir au club
            </p>
          </div>

          {/* Prochains événements */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
              Prochains événements
            </h2>
            <div className="max-w-5xl space-y-6">
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border-l-4 border-green-500 shadow-md">
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-12 h-12 bg-gradient-to-br from-green-600 to-emerald-600 rounded-xl flex items-center justify-center">
                        <Calendar className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <div className="flex items-center gap-2 flex-wrap">
                          <h3 className="text-xl font-bold text-gray-900">Repas de soutien pour Mélina Tissot</h3>
                          <span className="bg-red-500 text-white text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">Complet</span>
                        </div>
                        <div className="flex items-center text-green-600 font-medium text-sm">
                          <Clock className="w-4 h-4 mr-1" />
                          Vendredi 2 octobre 2026 · 18h30
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-700 leading-relaxed mb-2">
                      Centre sportif de Valeyres-sous-Montagny
                    </p>
                    <ul className="text-gray-700 text-sm space-y-1 list-disc list-inside">
                      <li>Fondue au fromage — 50.- par personne (enfant 15.-)</li>
                      <li>Apéro offert</li>
                      <li>Inscription &amp; paiement d'avance par Twint</li>
                    </ul>
                    <p className="text-green-700 font-semibold text-sm mt-3">
                      Informations et inscriptions au 079 953 99 71
                    </p>
                  </div>
                  <div
                    className="md:w-32 flex-shrink-0 cursor-pointer"
                    onClick={() => openLightbox([{ src: 'https://customer-assets-wrfwihn1.emergentagent.net/job_368c291c-62c1-4237-a0a2-a0b0ee1658d5/artifacts/ykgx53w5_Melina.jpeg', alt: 'Flyer Repas de soutien Mélina Tissot' }], 0)}
                    data-testid="melina-flyer-thumbnail"
                  >
                    <img
                      src="https://customer-assets-wrfwihn1.emergentagent.net/job_368c291c-62c1-4237-a0a2-a0b0ee1658d5/artifacts/ykgx53w5_Melina.jpeg"
                      alt="Flyer Repas de soutien Mélina Tissot"
                      className="w-full rounded-lg shadow-md hover:shadow-xl hover:scale-105 transition-all"
                    />
                    <p className="text-[10px] text-center text-gray-400 mt-1">Cliquez pour agrandir</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Événements passés */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
              Événements passés
            </h2>
            
            <div className="max-w-5xl">
              {pastEvents.map((event, index) => (
                <div key={index} className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 mb-6">
                  <div className="md:flex md:items-start md:gap-6">
                    {/* Info événement */}
                    <div className="md:w-1/3 mb-4 md:mb-0">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center">
                          <Calendar className="w-6 h-6 text-white" />
                        </div>
                        <div>
                          <h3 className="text-xl font-bold text-gray-900">{event.title}</h3>
                          <div className="flex items-center text-blue-600 font-medium text-sm">
                            <Clock className="w-4 h-4 mr-1" />
                            {event.date}
                          </div>
                        </div>
                      </div>
                      <p className="text-gray-700 leading-relaxed text-sm">{event.description}</p>
                    </div>
                    
                    {/* Galerie compacte */}
                    {event.images.length > 0 && (
                    <div className="md:w-2/3">
                        <div>
                          <h4 className="text-base font-semibold text-gray-900 mb-3 flex items-center">
                            <Camera className="w-4 h-4 mr-2" />
                            Photos ({event.images.length})
                          </h4>
                          <div className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-7 gap-2">
                            {event.images.map((image, imgIndex) => (
                              <div 
                                key={imgIndex}
                                onClick={() => openLightbox(event.images, imgIndex)}
                                className="relative group cursor-pointer rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 bg-white p-1"
                              >
                                <img 
                                  src={image.src}
                                  alt={image.alt}
                                  className="w-full h-16 object-cover rounded-md group-hover:scale-110 transition-all duration-300 filter brightness-110 contrast-110 saturate-110 group-hover:brightness-125"
                                />
                                <div className="absolute inset-1 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-md flex items-center justify-center">
                                  <ZoomIn className="w-4 h-4 text-white" />
                                </div>
                                
                                {/* Numéro de photo */}
                                <div className="absolute top-2 left-2 bg-blue-600 text-white text-xs font-bold w-4 h-4 rounded-full flex items-center justify-center">
                                  {imgIndex + 1}
                                </div>
                              </div>
                            ))}
                          </div>
                          <p className="text-xs text-gray-500 mt-2">Cliquez sur une photo pour voir la galerie complète</p>
                        </div>
                    </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Types d'événements organisés */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Types d'événements organisés
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl shadow-lg p-8 text-center hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Assemblée Générale</h3>
                <p className="text-gray-600">
                  Réunion annuelle du club pour le bilan et les projets futurs
                </p>
              </div>

              <div className="bg-white rounded-2xl shadow-lg p-8 text-center hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Calendar className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Tournois</h3>
                <p className="text-gray-600">
                  Tournois internes de tennis et padel pour tous les niveaux
                </p>
              </div>

              <div className="bg-white rounded-2xl shadow-lg p-8 text-center hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Stages Juniors</h3>
                <p className="text-gray-600">
                  Stages d'été et activités pour les jeunes joueurs
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EvenementsPage;